<template>
  <div class="flex flex-col gap-1 text-xl">
    <p>Name: {{ address.name }}</p>
    <p>Phone: {{ address.phone }}</p>
    <p class="h-10 flex flex-col justify-start">
      Address:
      <br />
      {{ address.street1
      }}{{ address.street2 !== "" ? " " + address.street2 : "" }}
    </p>
    <p>
      {{ address.city }}{{ address.state !== "" ? ", " + address.state : "" }}
    </p>
    <p class="font-bold text-2xl">{{ address.postalCode }}</p>
  </div>
</template>
<script>
export default {
  name: "OrderAddress",
  props: {
    address: {
      type: Object,
      required: true
    }
  }
};
</script>
